import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { catchError, map, switchMap } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import {
  LoadJobsiteExperience,
  LoadJobsiteExperienceComplete,
  LoadJobsiteExperienceFail,
  LS_LOAD_EXPERIENCE,
} from '../actions/jobsite-actions/jobsite.actions';
import { ExperiencesResponse, ExperiencesService } from '@cemex-core/cmx-api';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { LoadNextWorkingDayActionV5 } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/actions/next-working-day.actions';

@Injectable()
export class JobsiteLoadExperienceEffects implements IEffect {
  /**
   * Monitors the actions$ Actions stream (it's a sub-type of Observable) for
   * LS_LOAD_EXPERIENCE events; then attempts to get a jobsite's experience as
   * an ExperiencesResponse object from the injected ExperiencesService; and finally
   * handles success or failure when getting the experience details.
   * @type {Observable<LoadJobsiteExperienceComplete | LoadJobsiteExperienceFail>} the result of the address-loading operation
   */

  JobsiteLoadExperience$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD_EXPERIENCE),
      switchMap((action: LoadJobsiteExperience) => {
        return this.experienceService.getExperiences(action.payload.experiencesRequest).pipe(
          map((experiencesResponse: ExperiencesResponse) => {
            this.store.dispatch(
              new LoadNextWorkingDayActionV5({
                productLineCode: action.payload.experiencesRequest.productTypeCode,
                countryCode: action.payload.experiencesRequest.countryCode,
                jobsiteCode: action.payload.experiencesRequest.jobsiteCode,
              }),
            );
            return new LoadJobsiteExperienceComplete({
              experiencesResponse,
              salesDocumentTypeId: action.payload.salesDocumentTypeId,
            });
          }),
          catchError((error) => {
            const loadJobsiteExperienceComplete = {
              experiencesResponse: {
                _links: [],
                experiences: [
                  {
                    _links: [],
                    experienceId: 1,
                    isOnline: 0,
                    experienceCode: ORDER_EXPERIENCES.REQUEST,
                  },
                ],
              },
              salesDocumentTypeId: action.payload.salesDocumentTypeId,
            };
            this.store.dispatch(new LoadJobsiteExperienceComplete(loadJobsiteExperienceComplete));
            return of(new LoadJobsiteExperienceFail(error));
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private experienceService: ExperiencesService,
    private store: Store<OrderBuilderState>,
  ) {}
}
